import * as Yup from "yup";

const schema = Yup.object().shape({
  percentage: Yup.string().required("النسبة الحاصل عليها مطلوبة / Percentage is required"),
  year_obtaining_certificate: Yup.string().required("سنة الحصول على الشهادة مطلوبة / Year is required"),
  country_obtaining_certificate: Yup.string().required("بلد الحصول على الشهادة مطلوبة / Country is required"),
});

export default schema;
